"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepPyramid = void 0;
var _borderRadiusPolygon = require("./borderRadiusPolygon");
var _utils = require("./utils");
/* eslint-disable class-methods-use-this */

/**
 * This is a custom "step-pyramid" curve generator.
 * It creates a step pyramid, which is a step-like shape with static lengths.
 * It has the option to add a gap between sections while also properly handling the border radius.
 */
class StepPyramid {
  constructor(context, {
    isHorizontal,
    gap,
    position,
    borderRadius,
    min,
    max
  }) {
    this.context = void 0;
    this.position = 0;
    this.isHorizontal = false;
    this.gap = 0;
    this.borderRadius = 0;
    this.min = {
      x: 0,
      y: 0
    };
    this.max = {
      x: 0,
      y: 0
    };
    this.points = [];
    this.context = context;
    this.isHorizontal = isHorizontal ?? false;
    this.gap = (gap ?? 0) / 2;
    this.position = position ?? 0;
    this.borderRadius = borderRadius ?? 0;
    this.min = min ?? {
      x: 0,
      y: 0
    };
    this.max = max ?? {
      x: 0,
      y: 0
    };
  }
  areaStart() {}
  areaEnd() {}
  lineStart() {}
  lineEnd() {}
  getBorderRadius() {
    return this.gap > 0 || this.position === 0 ? this.borderRadius : [this.borderRadius, this.borderRadius];
  }
  point(xIn, yIn) {
    this.points.push({
      x: xIn,
      y: yIn
    });
    if (this.points.length < 4) {
      return;
    }

    // Add gaps where they are needed.
    this.points = this.points.map((point, index) => {
      if (this.isHorizontal) {
        const slopeEnd = {
          x: this.max.x,
          y: (this.max.y + this.min.y) / 2
        };
        const slopeStart = index <= 1 ? this.min : {
          x: this.min.x,
          y: this.max.y
        };
        const yGetter = (0, _utils.lerpY)(slopeStart.x, slopeStart.y, slopeEnd.x, slopeEnd.y);
        const xGap = point.x + (index === 0 || index === 3 ? this.gap : -this.gap);
        const xInitial = index === 0 || index === 1 ? this.points.at(0).x : this.points.at(3).x;
        return {
          x: xGap,
          y: yGetter(xInitial)
        };
      }
      const slopeEnd = {
        x: (this.max.x + this.min.x) / 2,
        y: this.max.y
      };
      const slopeStart = index <= 1 ? {
        x: this.max.x,
        y: this.min.y
      } : this.min;
      const xGetter = (0, _utils.lerpX)(slopeStart.x, slopeStart.y, slopeEnd.x, slopeEnd.y);
      const yGap = point.y + (index === 0 || index === 3 ? this.gap : -this.gap);
      const yInitial = index === 0 || index === 1 ? this.points.at(0).y : this.points.at(3).y;
      return {
        x: xGetter(yInitial),
        y: yGap
      };
    });
    (0, _borderRadiusPolygon.borderRadiusPolygon)(this.context, this.points, this.getBorderRadius());
  }
}
exports.StepPyramid = StepPyramid;